module.exports = __webpack_public_path__ + "static/media/bd.1cefe9c9.svg";